import { render, staticRenderFns } from "./EventAssignments.vue?vue&type=template&id=74e050ee&"
import script from "./EventAssignments.vue?vue&type=script&lang=ts&"
export * from "./EventAssignments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports